export default __webpack_public_path__ + "static/media/henry.7468c740.png";